<template>
	<div class="page">
		<Breadcrumb :pathList='pathList'></Breadcrumb>
		<div class="content">
			<div class="flex-only" style="margin-top: 20px;">
				<img :src="detail.img" style="width: 284px;height: 161px;border-radius: 13px;" />
				<div class="right flex-1">
					<div class="name">{{detail.train_cate_name}}</div>
					<!-- <div class="xy">加工中心学院</div> -->
				</div>
			</div>
			<div class="flex flex-b">
				<div class="titles">个人相关信息</div>
				<div class="tt">仅用于线下签到匹配对应人员</div>
			</div>
			<div class="gbox" style="margin-top: 0;">
				<div class="flex flex-b botl">
					<div class="t">手机号</div>
					<div class="t2">{{loginUser.phone}}</div>
				</div>
				<div class="flex flex-b botl">
					<div class="t">所属企业</div>
					<div class="t2">{{loginUser.business?loginUser.business:'暂未绑定公司'}}</div>
				</div>
				<div class="flex flex-b botl">
					<div class="t">真实姓名</div>
					<input class="inpt" type="text" v-model="name" placeholder="请输入姓名"
						placeholder-style="color:#999999;font-size: 16px;" />
				</div>
			</div>
			<div class="titles">培训相关信息</div>
			<div class="gbox">
				<div class="flex flex-b botl">
					<div class="t">培训时间</div>
					<div class="t2">{{detail.begin_time}} 至 {{detail.end_time}}</div>
				</div>
				<div class="flex flex-b botl">
					<div class="t">培训地点</div>
					<div class="t2">{{detail.address}}</div>
				</div>
				<div class="flex flex-b botl" v-if="detail.is_get_score==1">
					<div class="t">培训积分奖励</div>
					<div class="score4">{{detail.get_score}}<span>积分</span></div>
				</div>
			</div>


			<div class="wbox">
				<div class="tit">支付方式</div>
				<div class="gbox">
					<div class="flex flex-b botl" v-if="detail.pay_type==2">
						<div class="flex">
							<img src="../../assets/images/icon/iwx.png"
								style="width: 27px;height: 27px;margin-right: 20px;" alt="" />
							<div class="t1">微信支付</div>
						</div>
						<img src="../../assets/icon/xz.png" class="pointer"
							style="width: 18px;height: 18px;margin-left: 20px;" alt="" />
					</div>
					<div class="flex flex-b botl" v-if="detail.pay_type==1">
						<div class="flex">
							<img src="../../assets/images/icon/ijf.png"
								style="width: 27px;height: 27px;margin-right: 20px;" alt="" />
							<div class="t1">积分支付（可用：<img src="../../assets/images/icon/jb.png"
									style="width: 22px;height: 22px;" alt="" />{{loginUser.score}}）</div>
						</div>
						<img src="../../assets/icon/xz.png" class="pointer"
							style="width: 18px;height: 18px;margin-left: 20px;" alt="" />
					</div>
					<!-- 免费 -->
					<!-- <div class="flex flex-b botl" v-if="detail.pay_type==3">
						<div class="flex">
							<img src="../../assets/images/icon/iwx.png"
								style="width: 27px;height: 27px;margin-right: 20px;" alt="" />
							<div class="t1">微信支付</div>
						</div>
						<img src="../../assets/icon/xz.png" class="pointer" v-if="selPayType==1"
							style="width: 18px;height: 18px;margin-left: 20px;" alt="" />
						<img src="../../assets/icon/wxz.png" class="pointer" v-else @click="selPayType=1"
							style="width: 18px;height: 18px;margin-left: 20px;" alt="" />
					</div> -->
					<!-- <div class="flex flex-b botl" v-if="detail.pay_type==3">
						<div class="flex">
							<img src="../../assets/images/icon/ijf.png"
								style="width: 27px;height: 27px;margin-right: 20px;" alt="" />
							<div class="t1">积分支付（可用：<img src="../../assets/images/icon/jb.png"
									style="width: 22px;height: 22px;" alt="" />{{loginUser.score}}）</div>
						</div>
						<img src="../../assets/icon/xz.png" class="pointer" v-if="selPayType==2"
							style="width: 18px;height: 18px;margin-left: 20px;" alt="" />
						<img src="../../assets/icon/wxz.png" class="pointer" v-else @click="selPayType=2"
							style="width: 18px;height: 18px;margin-left: 20px;" alt="" />
					</div> -->
				</div>
				<div v-if="detail.pay_type!=3">
					<div class="flex flex-b mt10" v-if="detail.pay_type==2">
						<div class="t">培训费用</div>
						<div class="t2">¥{{detail.price}}</div>
					</div>
					<div class="flex flex-b mt10" v-if="detail.pay_type==1">
						<div class="t">积分抵扣</div>
						<div class="t2 ">{{detail.score}}</div>
					</div>
				</div>
				<div v-else>
					<div class="flex flex-b mt10">
						<div class="t">培训费用</div>
						<div class="t2">0</div>
					</div>
				</div>
				<div class="flex flex-b" style="border-top: 1px solid #EEEEEE;padding-top: 10px;margin-top: 10px;">
					<div class="t" style="font-weight: 600;">实付积分</div>
					<div class="price" v-if="detail.pay_type==2">¥{{detail.price}}</div>
					<div class="price" v-if="detail.pay_type==1">{{detail.score}}<span>积分</span></div>
					<div class="price" v-if="detail.pay_type==3">0</div>
				</div>
			</div>
			<div class="flex" style="margin-top: 60px;">
				<img src="../../assets/icon/wxz.png" v-if="!selectRule" @click="selectRule=!selectRule" class="pointer"
					style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
				<img src="../../assets/icon/xz.png" v-else @click="selectRule=!selectRule" class="pointer"
					style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
				<div class="tip">我已阅读并同意以下内容<span class="pointer">报名须知</span>以及<span class="pointer">合同条款</span></div>
			</div>
		</div>
		<div class="bottomFixed flex flex-b">
			<div v-if="detail.pay_type!=3">
				<div class="price" v-if="detail.pay_type==2">¥{{detail.price}}</div>
				<div class="price" v-else>{{detail.score}}积分</div>
			</div>
			<div v-else>
				<div class="price">0</div>
			</div>
			<div class="login-btn pointer" @click="toClickBuy"><span class="text">立即报名</span></div>
		</div>

		<el-dialog :visible.sync="buySuccess" width="382" center :show-close="false">
			<div class="flex-column-item">
				<img src="../../assets/images/course/success.png" style="width: ;height: 53px;" alt="" />
				<div class="mt10" style="font-size: 16px;color: #666666;">已完成报名</div>
			</div>
			<div class="flex flex-b">
				<div class="wxbtn pointer" style="width: 156px;height: 46px;"
					@click="buySuccess=false,$router.push('/myTraining')">我知道了</div>
				<div class="login-btn pointer" @click="$router.push('/myTraining')">
					<span class="text">前往查看</span>
				</div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="wxPay" width="500" center :show-close="true" title="微信支付">
			<div class="dialog flex-column-item">
				<div class="money">应付金额：<span>¥1</span></div>
				<div class="subTime">剩余支付时间<span>29分59秒</span>，超时请重新发起订单</div>
				<div class="ewm"></div>
				<div class="tt">请使用微信扫码支付</div>
				<div class="wxbtn pointer" style="width: 156px;height: 46px;" @click="wxPay=false">我已支付</div>
			</div>
		</el-dialog>
		<!-- <Toast ref="toastRef"></Toast> -->

		<el-dialog :visible.sync="showShare" width="438px" center :show-close="false">
			<div class="shareBg flex-column-item" ref="posterContainer">
				<div class="ewm flex-column-item">
					<div ref="qrcodeContainer1"></div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Utils from "@/jslibs/utils";
	import {
		getMyCourse,
		getUser,
		EditUser,
	} from '@/api/mine';
	import {
		getTrainDetail,
		getTrainOrder
	} from "@/api/train";
	import {
		getMember
	} from "@/api/common";
	import Toast from '../../components/Toast.vue';
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import html2canvas from 'html2canvas';
	import QRCode from 'qrcodejs2'; // 引入二维码库
	export default {
		data() {
			return {
				showShare: false,
				pathList: [{
						title: '培训列表',
						path: '/training'
					},
					{
						title: '培训详情',
						path: ''
					},
					{
						title: '报名确认',
						path: ''
					}
				],
				buySuccess: false, //支付成功
				wxPay: false, //微信支付
				detail: '',
				memberName: '',
				loginUser: '',
				selectRule: false,
				selPayType: 1,
				name: '',
				uuid: '',
				qrContent: '', // 需要编码的内容
				qrCodeInstance: null, // 用于保存二维码实例
				inviteImgUrl: '',
				setInterval: ''
			}
		},
		components: {
			Toast,
			Breadcrumb
		},
		mounted() {
			if (Utils.getCookie('loginUser')) {
				this.getUser()
			}
			this.uuid = this.$route.query.id
			this.pathList[1].path = '/trainingDetail?id=' + this.uuid
			this.getTrainDetail()
			// this.$nextTick(() => {
			// 	this.$refs.toastRef.openToast('支付已取消')
			// 	// this.$refs.toastRef.openToast('账户余额不足')
			// 	// this.$refs.toastRef.openToast('培训已下架')
			// 	// this.$refs.toastRef.openToast('已超过报名时间')
			// 	// this.$refs.toastRef.openToast('已无剩余可报名名额')
			// })
		},
		destroyed() {
			clearInterval(this.setInterval)
		},
		methods: {
			async getUser() {
				const {
					status,
					data
				} = await getUser({})
				this.loginUser = data.result
			},
			async toClickBuy() {
				if (!this.selectRule) {
					this.$message({
						message: "请阅读并同意以下内容《报名须知》以及《合同条款》",
						type: "warning"
					});
					return
				}
				if (!this.name) {
					this.$message({
						message: "请填写真实姓名",
						type: "warning"
					});
					return
				}
				const {
					status,
					data
				} = await getTrainOrder({
					name: this.name,
					pay_type: this.detail.pay_type,
					train_uuid: this.uuid,
					platform: this.detail.pay_type
				});
				if (data.result && this.detail.pay_type == 1) {
					this.buySuccess = true
				}
				if (data.result && this.detail.pay_type == 2) {
					this.showShare = true
					this.$nextTick(() => {
						this.$refs.qrcodeContainer1.innerHTML = '';

						this.qrCodeInstance = new QRCode(this.$refs.qrcodeContainer1, {
							text: data.result.code_url, // 二维码内容
							width: 268, // 宽度
							height: 268, // 高度
							colorDark: "#000000", // 二维码颜色
							colorLight: "#ffffff", // 背景色
							correctLevel: QRCode.CorrectLevel.H // 容错级别
						});
					})
					this.setInterval = setInterval(() => {
						this.getTrainDetailRest()
					}, 5000)
				}
			},
			async getTrainDetailRest() {
				const {
					data,
					status
				} = await getTrainDetail({
					uuid: this.uuid,
				})
				if (data.result.is_order == 1) {
					this.showShare = false
					this.buySuccess = true
					clearInterval(this.setInterval)
				}
			},
			async getTrainDetail() {
				const {
					data,
					status
				} = await getTrainDetail({
					uuid: this.uuid,
				})
				this.detail = data.result
				this.pathList[1].title = this.detail.name
				this.getMember()
			},
			async getMember() {
				const {
					data,
					status
				} = await getMember({
					uuid: this.detail.member_uuid,
				})
				this.memberName = data.result.name
			},
			goBack() {
				this.$router.go(-1)
			},
			toPage(path) {
				this.$router.push({
					path: path
				})
			},
		},
	}
</script>

<style lang="less" scoped>
	.shareBg {
		background-size: 100%;
		position: relative;

		.ewm {
			width: 298px;
			height: 298px;
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 24px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.login-btn {
		width: 160px;
		height: 52px;
		background: url('../../assets/images/course/btnw164.png') no-repeat;
		background-size: 100% 100%;
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.wxbtn {
		margin-top: 20px;
		width: 360px;
		height: 51px;
		border-radius: 12px 12px 12px 12px;
		border: 2px solid rgba(127, 218, 76, .24);
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 16px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.page {
		padding: 30px 133px 120px;

		.content {
			margin: 30px 233px 0;
			border-top: 4px solid rgba(0, 167, 60, 0.24);

			.right {
				margin-left: 20px;

				.name {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 27px;
					color: #000000;
				}

				.xy {
					margin-top: 10px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #999999;
				}
			}

			.gbox {
				background: #FAFBFC;
				border-radius: 13px 13px 13px 13px;
				padding: 10px 20px;
				margin: 20px 0;
			}

			.tt {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
			}

			.wbox {
				background: #FFFFFF;
				box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
				border-radius: 13px 13px 13px 13px;
				padding: 20px;
				margin: 20px 0;

				.tit {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 18px;
					color: #333333;
				}

				.vipName {
					margin-left: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #D7B155;
				}
			}

			.inpt {
				text-align: right;
				border: none;
				background: transparent;

				&:focus {
					outline: none;
				}

				&::placeholder {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 16px;
					color: #999999;
				}
			}

			.botl {
				padding: 16px 0;
				border-bottom: 1px solid #EEEEEE;

				&:last-child {
					border-bottom: none;
				}
			}

			.t {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
			}

			.t1 {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 16px;
				color: #333333;
			}

			.t2 {
				font-family: DINPro, DINPro;
				font-weight: 500;
				font-size: 16px;
				color: #333333;
			}

			.tip {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;

				span {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 13px;
					color: #00A73C;
				}
			}
		}

		.mt10 {
			margin-top: 10px;
		}

		.price {
			font-family: DINPro, DINPro;
			font-weight: bold;
			font-size: 22px;
			color: #00A73C;

			span {
				margin-left: 4px;
				font-family: DINPro, DINPro;
				font-weight: 400;
				font-size: 16px;
				color: #00A73C;
			}
		}

		.score4 {
			font-family: DINPro, DINPro;
			font-weight: bold;
			font-size: 22px;
			color: #00A73C;

			span {
				margin-left: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #00A73C;
			}
		}

		.bottomFixed {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			padding: 20px 356px;
			z-index: 999;

			.t1 {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #000000;
			}

			.login-btn {
				width: 276px;
				height: 50px;
				background: url('../../assets/images/login/loginbtn.png') no-repeat;
				background-size: 100% 100%;
				margin-top: 13px;
				display: flex;
				align-items: center;
				justify-content: center;

				.text {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 16px;
					text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
					text-align: center;
					font-style: normal;
					text-transform: none;
					background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
			}
		}
	}

	::v-deep .el-dialog__title {
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 500;
		font-size: 20px;
		color: #000000;
	}

	.dialog {
		.money {
			margin: 10px 0;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 18px;
			color: #000000;

			span {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #00A73C;
			}
		}

		.subTime {
			white-space: nowrap;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 18px;
			color: #666666;

			span {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #000;
			}
		}

		.ewm {
			margin: 20px 0;
			width: 276px;
			height: 276px;
		}

		.tt {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #999999;
		}
	}
</style>